import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withActions } from '../../../../api';

import { reorder } from '../other';
import { updateCategoriesDispatch } from '../../../../reducers/shops';
import SortCategories from './sortCategories';

const SortModeProducts = (props) => {
    const categories = useSelector(state => state.shops.categories);
    const language = useSelector(state => state.shops.defaultLanguage);
    const dispatch = useDispatch();

    const [openModal, setOpenModal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [submitData, setSubmitData] = useState(null);
    const [categoriesList, setCategoriesList] = useState(null);

    const handleClose = () => {
        setOpenModal(false);
        setIsSubmit(false);
    };

    const handleClickSubmit = () => {
        setOpenModal(false);
        setIsSubmit(true);
    };

    const getCategoriesList = () => {
        const categoriesData = Array.isArray(categories)
            ? [...categories]
            : Object.values(categories || {});

        const data = categoriesData
            .filter(item => item && item.id)
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map(item => ({
                id: item.id,
                name: item.name && item.name[language],
                order: item.order,
            }));

        if (data.length > 0) setCategoriesList(data);
    }

    useEffect(() => {
        if (isSubmit) {
            handleSubmit(submitData);
            setOpenModal(false);
        };
    }, [isSubmit]);

    useEffect(() => {
        if (!categoriesList && categories) getCategoriesList();
    }, [categoriesList, categories]);

    const onDragEnd = (result) => {
        if (!result.destination) {
          return;
        }

        let data = reorder(
          categoriesList,
          result.source.index,
          result.destination.index,
        );

        const sortData = data.map((item, index) => ({
            id: item.id,
            order: index + 1,
        }));

        setCategoriesList(data);
        setSubmitData(sortData);
    }

    const clearStateByProducts = () => {
        setIsSubmit(false);
        setSubmitData(null);
    };

    const applyCategoriesOrder = (orderData, updatedCategories) => {
        const categoriesData = Array.isArray(updatedCategories)
            ? updatedCategories
            : Array.isArray(categories)
                ? [...categories]
                : Object.values(categories || {});
        const orderById = orderData.reduce((acc, item) => {
            acc[item.id] = item.order;
            return acc;
        }, {});
        const nextCategories = categoriesData
            .map(item => ({
                ...item,
                order: orderById[item.id] || item.order,
            }))
            .sort((a, b) => (a.order || 0) - (b.order || 0));

        updateCategoriesDispatch(dispatch, nextCategories);
        setCategoriesList(nextCategories.map(item => ({
            id: item.id,
            name: item.name && item.name[language],
            order: item.order,
        })));
    };

    const sendToUpdateApi = async (data) => {
        const res = await props.updateCategoriesSortOrder({ categories: data });

        if (res?.isError) {
            console.error(res.message);
            clearStateByProducts();
            return;
        }

        applyCategoriesOrder(data, res?.categories);
        clearStateByProducts();
    }

    const handleSubmit = (data) => {
        console.log('submit data', data);

        if (!data) {
            clearStateByProducts();
        } else {
            sendToUpdateApi(data);
        }
    }

    return (
        <SortCategories 
            openModal={openModal}
            categoriesList={categoriesList}
            handleClose={handleClose}
            handleClickSubmit={handleClickSubmit}
            onDragEnd={onDragEnd}
            setOpenModal={setOpenModal}
        />
    )
}

export default withActions(withRouter(SortModeProducts));
